export interface IAirportConfiguration {
  iataCode: string;
  name: string;
  timeZoneId: string;
  icaoCode?: string;
  timeZone?: string;
  location?: [number, number];
}

let airportConfig: IAirportConfiguration[] = [];

export const setAirportConfiguration = (config: IAirportConfiguration[]) => {
  airportConfig = config;
};

export const getAirportConfiguration = (): IAirportConfiguration[] =>
  airportConfig;
